import { library } from '@fortawesome/fontawesome-svg-core';
import { faHandPointer, faAnchor, faSpinner, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';

library.add(faHandPointer, faAnchor, faSpinner, faCaretLeft, faCaretRight);
